<div [ngClass]="{ card: true, 'employee-card': true }" #employeeCard>
  <div class="card-horizontal">
    <div class="img-square-wrapper mx-2" [ngStyle]="{ background: getBackgroundColor() }"></div>
    <div class="card-body d-flex align-items-center">
      <p class="card-text-active mb-0">{{ employeeTitle?.name }}</p>
    </div>
  </div>
</div>
